function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { __rest } from "tslib";
import React, { useEffect } from 'react';
export function Adsense(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$style = _a.style,
      style = _a$style === void 0 ? {
    display: 'block'
  } : _a$style,
      client = _a.client,
      slot = _a.slot,
      _a$layout = _a.layout,
      layout = _a$layout === void 0 ? '' : _a$layout,
      _a$layoutKey = _a.layoutKey,
      layoutKey = _a$layoutKey === void 0 ? '' : _a$layoutKey,
      _a$format = _a.format,
      format = _a$format === void 0 ? 'auto' : _a$format,
      _a$responsive = _a.responsive,
      responsive = _a$responsive === void 0 ? 'false' : _a$responsive,
      _a$pageLevelAds = _a.pageLevelAds,
      pageLevelAds = _a$pageLevelAds === void 0 ? false : _a$pageLevelAds,
      adTest = _a.adTest,
      children = _a.children,
      rest = __rest(_a, ["className", "style", "client", "slot", "layout", "layoutKey", "format", "responsive", "pageLevelAds", "adTest", "children"]);

  useEffect(function () {
    var p = {};

    if (pageLevelAds) {
      p.google_ad_client = client;
      p.enable_page_level_ads = true;
    }

    try {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
        (window.adsbygoogle = window.adsbygoogle || []).push(p);
      }
    } catch (_a) {// Pass
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/React.createElement("ins", Object.assign({
    className: "adsbygoogle ".concat(className),
    style: style,
    "data-ad-client": client,
    "data-ad-slot": slot,
    "data-ad-layout": layout,
    "data-ad-layout-key": layoutKey,
    "data-ad-format": format,
    "data-full-width-responsive": responsive,
    "data-adtest": adTest
  }, rest), children);
}